import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { Address, AddressUpdate } from "@spare-cart/contracts/checkout";
import { apiClient } from "@core/api";
import { addressKeys } from "./addressKeys";

export type UpdateAddressInput = AddressUpdate & { addressId: string };

export const useUpdateAddress = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ addressId, ...body }: UpdateAddressInput) =>
      apiClient.patch<Address>(`/addresses/${addressId}`, body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: addressKeys.lists() });
    },
  });
};
